import { Theme } from '@mos-cat/ds-theme';
import { BoxHTMLProps } from 'reakit';
import { createComponent, createHook } from 'reakit-system';
import { ResponsiveValue } from 'styled-system';

import { ecss, cx } from '../reexports/emotion';
import { BoxOptions, useBox } from '../Box/Box';
import { StylesOptions, useStyles } from '../hooks/useStyles';
import { useTheme } from '../hooks/useTheme';

export type StackOptions = BoxOptions & {
  space: ResponsiveValue<keyof Theme['space']>;
} & StylesOptions;

export type StackHTMLProps = BoxHTMLProps;

export type StackProps = StackOptions & StackHTMLProps;

export const useStack = createHook<StackOptions, BoxHTMLProps>({
  name: 'Stack',
  keys: ['space'],
  compose: [useTheme, useBox, useStyles],
  useOptions(options): StackOptions {
    return {
      ...options,
      styles: {
        ...(options.styles || {}),
        display: ['flex'],
        flexDirection: ['column'],
        justifyContent: ['flex-start'],
        '& > * + *': {
          mt: options.space as ResponsiveValue<'mt', Theme>,
        },
      },
    };
  },
  useProps(options, props) {
    return {
      ...props,
      className: cx(props.className, ecss({ label: 'Stack' })),
    };
  },
});

export const Stack = createComponent({
  useHook: useStack,
  as: 'div',
  memo: true,
});
